module.exports = __webpack_public_path__ + "media/images/niq-logo-on-white-08b9ddf971cd29576f857b8eeb4a366c.svg";